module.exports = __webpack_public_path__ + "static/img/atul.f40e00b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/atul.png
// module id = xhnP
// module chunks = 1